module.exports = "<div [formGroup]=\"formGroup\">\n<div class=\"form-group\">\n  <label *ngIf=\"label != undefined && label != null && label.length > 0\">{{label}}</label>\n  <my-date-picker [options]=\"options\" class=\"{{classDataPicker}}\" [locale]=\"locale\" formControlName=\"{{formControlName}}\" (dateChanged)=\"onChangeDate($event)\" [(ngModel)]=\"value\"></my-date-picker>\n</div>\n<div class=\"alert alert-danger {{classError}}\" role=\"alert\" style=\"display: none;\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/data-picker/data-picker.component.html
// module id = ./src/app/shared/componentes/data-picker/data-picker.component.html
// module chunks = main